import type {
  SearchExternalAccountInfosRequest,
  SearchExternalAccountInfosResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/integrations/partners/v1/external_account_info_api';
import type {
  ExchangeAuthorizationCodeRequest,
  FilterPlatformsRequest,
  FilterPlatformsResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/integrations/partners/v1/platform_api';
import type {
  BatchGetAccountsRequest,
  BatchGetAccountsResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/integrations/partners/v2/account_api';
import { awIntegrationsApi } from './Base';

export function getPlatforms(payload: FilterPlatformsRequest) {
  const path = '/partners/v1/platforms:filter';
  return awIntegrationsApi.post<FilterPlatformsResponse>(path, payload);
}

export function exchangeAuthCode(payload: ExchangeAuthorizationCodeRequest) {
  const path = `/partners/v1/platforms:exchangeAuthorizationCode`;
  return awIntegrationsApi.post(path, payload);
}

export function searchExternalAccountInfos(payload: SearchExternalAccountInfosRequest) {
  const path = '/partners/v1/externalAccountInfos:search';
  return awIntegrationsApi.post<SearchExternalAccountInfosResponse>(path, payload);
}

export function batchGetExternalAccounts(payload: BatchGetAccountsRequest) {
  const path = '/partners/v2/accounts:batchGet';
  return awIntegrationsApi.post<BatchGetAccountsResponse>(path, payload);
}
